import React, { Component } from 'react';
import Button from '../../components/UI/Button/Button';
import Modal from '../../components/UI/Modal/Modal';

class HowTo extends Component {
    state = {
        modalOpenState: false
    }

    openModal = () => {
        if(this.props.vimeoPlayer){
            this.props.vimeoPlayer.pause();
        }
        // document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        this.setState({ modalOpenState: true });
    }
    closeModal = () => {
        // document.getElementsByTagName('body')[0].style.overflow = 'auto';
        this.setState({ modalOpenState: false });
    }

    render() {
        let modal = this.state.modalOpenState ? <Modal click={this.closeModal} /> : null;
        
        return (
            <>
                <Button click={this.openModal} />
                {modal}
            </>
        );
    }
}

export default HowTo;